// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.export-confirmation-modal .ant-modal-content {
  border-radius: 10px;
  padding: 24px 28px;
}
.export-confirmation-modal .ant-modal-close {
  top: 12px;
  inset-inline-end: 12px;
}
.export-confirmation-modal .export-modal-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}
.export-confirmation-modal .export-modal-header {
  display: flex;
  align-items: left;
  gap: 10px;
  margin-bottom: 16px;
}
.export-confirmation-modal .export-modal-icon {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: #e8f3ff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 26px;
  color: #1677ff;
}
.export-confirmation-modal .export-modal-title {
  font-size: 18px;
  font-weight: 600;
  color: #1d1d4f;
  margin: 0;
}
.export-confirmation-modal .export-modal-text {
  color: #555;
  font-size: 15px;
  margin: 8px 0 24px;
}
.export-confirmation-modal .export-modal-buttons {
  display: flex;
  justify-content: center;
  gap: 12px;
}
.export-confirmation-modal .export-modal-buttons .export-btn-confirm {
  background-color: #d32f2f;
  border: none;
  color: #fff;
  font-weight: 500;
  padding: 6px 20px;
  border-radius: 6px;
  transition: background 0.2s;
}
.export-confirmation-modal .export-modal-buttons .export-btn-confirm:hover {
  background-color: #b71c1c;
}
.export-confirmation-modal .export-modal-buttons .export-btn-cancel {
  border: 1px solid #ccc;
  color: #333;
  padding: 6px 20px;
  border-radius: 6px;
  background-color: #fff;
  transition: all 0.2s;
}
.export-confirmation-modal .export-modal-buttons .export-btn-cancel:hover {
  border-color: #999;
}`, "",{"version":3,"sources":["webpack://./src/components/reusable/ExportConfirmationModal/ExportConfirmationModal.scss"],"names":[],"mappings":"AACE;EACE,mBAAA;EACA,kBAAA;AAAJ;AAGE;EACE,SAAA;EACA,sBAAA;AADJ;AAIE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;AAFJ;AAKE;EACE,aAAA;EACA,iBAAA;EACA,SAAA;EACA,mBAAA;AAHJ;AAME;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,cAAA;AAJJ;AAOE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;AALJ;AAQE;EACE,WAAA;EACA,eAAA;EACA,kBAAA;AANJ;AASE;EACE,aAAA;EACA,uBAAA;EACA,SAAA;AAPJ;AASI;EACE,yBAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,2BAAA;AAPN;AASM;EACE,yBAAA;AAPR;AAWI;EACE,sBAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,oBAAA;AATN;AAWM;EACE,kBAAA;AATR","sourcesContent":[".export-confirmation-modal {\r\n  .ant-modal-content {\r\n    border-radius: 10px;\r\n    padding: 24px 28px;\r\n  }\r\n\r\n  .ant-modal-close {\r\n    top: 12px;\r\n    inset-inline-end: 12px;\r\n  }\r\n\r\n  .export-modal-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    text-align: center;\r\n  }\r\n\r\n  .export-modal-header {\r\n    display: flex;\r\n    align-items: left;\r\n    gap: 10px;\r\n    margin-bottom: 16px;\r\n  }\r\n\r\n  .export-modal-icon {\r\n    width: 50px;\r\n    height: 50px;\r\n    border-radius: 50%;\r\n    background-color: #e8f3ff;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    font-size: 26px;\r\n    color: #1677ff;\r\n  }\r\n\r\n  .export-modal-title {\r\n    font-size: 18px;\r\n    font-weight: 600;\r\n    color: #1d1d4f;\r\n    margin: 0;\r\n  }\r\n\r\n  .export-modal-text {\r\n    color: #555;\r\n    font-size: 15px;\r\n    margin: 8px 0 24px;\r\n  }\r\n\r\n  .export-modal-buttons {\r\n    display: flex;\r\n    justify-content: center;\r\n    gap: 12px;\r\n\r\n    .export-btn-confirm {\r\n      background-color: #d32f2f;\r\n      border: none;\r\n      color: #fff;\r\n      font-weight: 500;\r\n      padding: 6px 20px;\r\n      border-radius: 6px;\r\n      transition: background 0.2s;\r\n\r\n      &:hover {\r\n        background-color: #b71c1c;\r\n      }\r\n    }\r\n\r\n    .export-btn-cancel {\r\n      border: 1px solid #ccc;\r\n      color: #333;\r\n      padding: 6px 20px;\r\n      border-radius: 6px;\r\n      background-color: #fff;\r\n      transition: all 0.2s;\r\n\r\n      &:hover {\r\n        border-color: #999;\r\n      }\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
